import { render, staticRenderFns } from "./BidStrategiesSubtypeMappings.vue?vue&type=template&id=cca70a8a"
import script from "./BidStrategiesSubtypeMappings.vue?vue&type=script&lang=js"
export * from "./BidStrategiesSubtypeMappings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports